import React from 'react';

const ContactSection: React.FC = () => {
  return (
    <section 
      id="contacto" 
      className="section-hyper scroll-snap-section contact-hyper"
    >
      <div className="contact-background-pattern" />
      
      <div className="section-content-hyper contact-content">
        
        {/* Main CTA Section */}
        <div className="contact-cta-section parallax-element">
          <h2 className="section-title-hyper contact-title">
            ¿Arrancamos?
          </h2>
          
          <p className="contact-subtitle">
            Únete a la revolución de la movilidad compartida
          </p>
          
          <a
            href="https://wa.me/5491153873721"
            target="_blank"
            rel="noopener noreferrer"
            className="modern-cta-button"
          >
            
            <i className='bi bi-whatsapp'></i>Quiero participar
          </a>
        </div>

        {/* Contact Info Grid */}
        <div className="contact-info-section">
          <div className="contact-details-grid">
            
            {/* Contact Information */}
            <div className="contact-info-column">
              <h3 className="contact-section-title">Contacto</h3>
              <div className="contact-item">
                <span className="contact-icon"><i className="bi bi-envelope-at-fill"></i></span>
                <div>
                  <strong>Email</strong>
                  <p>Info@arrankonline.com</p>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon"><i className="bi bi-whatsapp"></i></span>
                <div>
                  <strong>Administración</strong>
                  <p>+54 9 11 5387-3721</p>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon"><i className="bi bi-whatsapp"></i></span>
                <div>
                  <strong>Queres rentabilizar tu auto.</strong> 
                  <strong>Captación Propietarios</strong>
                  <p>+54 9 11 7200-3387</p>
                  <p>+54 9 11 2694-2329</p>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon"><i className="bi bi-whatsapp"></i></span>
                <div>
                  <strong>Captación - Conductores</strong>
                  <p>+54 9 11 6865-3099</p>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon"><i className="bi bi-geo-alt-fill"></i></span>
                <div>
                  <strong>Dirección</strong>
                  <p>
                    Aráoz 1233, Palermo, CABA.<br />
                    <a href="https://maps.app.goo.gl/6c8C3WLD2F7gnUX2A" target="_blank" rel="noopener noreferrer">Ver en Google Maps</a>
                  </p>
                </div>
              </div>
            </div>

            {/* Google Maps */}
            <div className="contact-map-column">
              <h3 className="contact-section-title">Nuestra Ubicación</h3>
              <div className="contact-map-container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.9999999999995!2d-58.42999999999999!3d-34.599999999999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcca99aaaaaaaa%3A0xaaaaaaaaaaaaaaaa!2sAr%C3%A1oz%201233%2C%20C1414%20CABA!5e0!3m2!1ses!2sar!4v1692816000000!5m2!1ses!2sar"
                  width="100%"
                  height="200"
                  style={{ border: 0, borderRadius: '12px' }}
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Arrank Ubicación"
                ></iframe>
              </div>
            </div>
          </div>
          
          <div className="contact-bottom">
            <p className="contact-description">
              Conectamos autos con conductores de forma segura y rentable
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
